import { create } from 'zustand';
import { IPracticeRevision } from '../model';

interface IPracticeRevisionState {
  practiceRevision: IPracticeRevision[];
  setPracticeRevision: (practiceRevision: IPracticeRevision[]) => void;
}

export const practiceRevisionStore = create<IPracticeRevisionState>((set) => ({
  practiceRevision: [],
  setPracticeRevision: (practiceRevision: IPracticeRevision[]) =>
    set({ practiceRevision }),
}));
